import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AppDispatch } from "state";
import { AccountState } from "state/types";
import getAccount, { GetAccountResponse } from "./getAccount";




const initialState: AccountState = {
    isInitialized: false,
    isLoading: true,
    data:null
}

export const accountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {
        accountFetchStart: (state) => {
            state.isLoading = true
        },
        accountFetchSucceeded: (_state,action:PayloadAction<GetAccountResponse>) => {
            const { account } = action.payload
            
            return {
                isInitialized: true,
                isLoading: false,
                data: account,
              }
        },
        accountFetchFailed: (state) => {
            state.isLoading = false
            state.isInitialized = true
        },
        accountClear: () => ({
            ...initialState,
            isLoading: false,
        })
    }
})

// Actions
export const { accountFetchStart, accountFetchSucceeded, accountFetchFailed, accountClear } = accountSlice.actions

// Thunks
// TODO: this should be an AsyncThunk
export const fetchAccount = (address: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(accountFetchStart())
      const response = await getAccount(address)
      dispatch(accountFetchSucceeded(response))
    } catch (error) {
      dispatch(accountFetchFailed())
    }
}
  
  export default accountSlice.reducer